import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import MaterialsCategoriesApi from '@/services/apiServiceModules/materialsCategoriesApi'
const materialsCategoriesApi = new MaterialsCategoriesApi()

export default class MaterialsCategoriesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.MATERIALS_CATEGORIES, materialsCategoriesApi, {
			useCache: true,
		})
	}
}